const stylesTableDarkMode = {
    title: {
        borderBottom: '4px solid #495057'
    },
    header: {
        textAlign: 'left',
        padding: '8px',
        backgroundColor: '#333',
        border: '1px solid #555',
        color: '#fff',
    },
    cell: {
        padding: '8px',
        border: '1px solid #555',
        color: '#fff',
    },
    expandedEvenCell: {
        padding: '8px',
        border: '1px solid #555',
        color: '#fff',
    },
    expandedOddCell: {
        padding: '8px',
        border: '1px solid #555',
        color: '#fff',
    },
    evenRow: {
        backgroundColor: '#444',
    },
    oddRow: {
        backgroundColor: '#555',
    },
    buttonAgregar: {
        width: '25%',
        backgroundColor: '#7D1B29',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },
    buttonHoverAgregar: {
        backgroundColor: '#641723'
    },
    buttonHoverCancelar: {
        backgroundColor: '#969696'
    },    
    button: {
        width: '75%',
        backgroundColor: '#3d8bfd',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },
    buttonHover: {
        backgroundColor: '#0a58ca'
    },
    divider: {
        height: '1px',
        backgroundColor: '#ccc',
        marginTop: 10,
        marginBottom: 10,
        width: '100%'
    },
    logoutButtonUpRight: {
        position: "absolute",
        top: "15px",
        right: "120px",
        backgroundColor: "#A23C41",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "16px",
        fontWeight: "bold",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background 0.3s",
    },
    logoutButton: {
        top: "15px",
        right: "120px",
        backgroundColor: "#A23C41",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "20px",
        fontWeight: "bold",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background 0.3s",
    },
    logoutButtonHover: {
        backgroundColor: "#972034",
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        minWidth: "300px",
        backgroundColor: '#212529',
    },
    modalSaveButton: {
        marginTop: "10px",
        padding: "8px 15px",
        backgroundColor: "#A23C41",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: 20,
        fontWeight: 'bold',
        width: '40%'
    },    
    modalCloseButton: {
        marginTop: "10px",
        padding: "8px 15px",
        backgroundColor: "#cccccc",
        color: "#A23C41",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: 20,
        fontWeight: 'bold',
        width: '40%',
    },
    separator: {
        width: '100%',
        height: '2px',
        backgroundColor: "#495057",
        marginBottom: 10
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
        fontSize: 18,
        backgroundColor: '#343a40', // Gris oscuro
        padding: 10,
        borderRadius: 8,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    },
    label: {
        fontWeight: 'bold',
        color: '#f8f9fa', // Texto blanco
        minWidth: 150,
    },
    input: {
        flex: 1,
        padding: 8,
        fontSize: 16,
        border: '1px solid #6c757d', // Gris medio
        borderRadius: 5,
        outline: 'none',
        backgroundColor: '#495057', // Gris más claro que el fondo
        color: '#f8f9fa', // Texto blanco
        transition: 'border 0.3s ease-in-out',
    },
    inputFocus: {
        border: '1px solid #0F6EFD',
    },
    expandedEvenRow: {
        backgroundColor: "#212529", //"#212529"
        padding: "10px",
        textAlign: "center",
        border: '1px solid #555'
    },       
    expandedOddRow: {
        backgroundColor: "#212529",
        padding: "10px",
        textAlign: "center",
        border: '1px solid #555'
    },
    tituloCategoria: {
        fontSize: 24
    },
    buttonEditar: {
        width: '25%',
        // backgroundColor: '#3a3f51',
        backgroundColor: '#556080',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },      
    editButton: {
        backgroundColor: "#556080",
        color: "white",
    },
    editButtonHover: {
        // backgroundColor: "#556080",
        backgroundColor: "#3a3f51",
    },   
    container: {
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#444c54'
    },  
    card: {
        marginTop: 50,
        backgroundColor: '#212529',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        width: '40%',
        textAlign: 'center'
    },   
    loginTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '20px'
    },  
    loginLabel: {
        display: 'block',
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '5px'
    },    
    footerText: {
        marginTop: '15px',
        fontSize: '14px',
        color: '#fff'
    },
    buttonVerificar: {
        backgroundColor: '#2D9CDB',
        width: '25%',
        color: 'white',
        border: 'none',
        padding: 10,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',        
    },
    verificarButtonHover: {
        backgroundColor: "#1B7CB3",
    },    
}

export default stylesTableDarkMode;